import { useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import Button from '../../../../components/Button/Button';
import Heading from '../../../../components/Heading/Heading.styled';
import Price from '../../../../components/Price/Price';
import {
  ControlsWrapperStyled,
  SectionWrapperStyled,
  TopSectionStyled,
} from '../../PaymentDetailsPage.styled';
import { PriceWrapperStyled, WarningStyled } from './Total.styled';

type TotalPropsT = {
  showSAText: boolean;
  isLoading?: boolean;
  total: number;
  onClickTermsAndCondition: () => void;
  onClickPrivacyPolicy: () => void;
  onClickNext: () => void;
};

const Total: React.FC<TotalPropsT> = ({
  showSAText,
  isLoading,
  total,
  onClickTermsAndCondition,
  onClickPrivacyPolicy,
  onClickNext,
}) => {
  const { isValid } = useFormikContext();
  const navigate = useNavigate();

  return (
    <SectionWrapperStyled>
      <TopSectionStyled>
        <Heading level={3} transform="capitalize">
          <FormattedMessage id="common.totalPrice" defaultMessage="Total price" />
        </Heading>

        <PriceWrapperStyled>
          <Price amount={total} />
        </PriceWrapperStyled>
      </TopSectionStyled>

      <FormattedMessage
        id="totalPrice.info.text1"
        defaultMessage="<p>By clicking 'next' you agree to <link-terms-and-conditions>Wayaj.com Terms & Conditions</link-terms-and-conditions> and <link-privacy-policy>Wayaj.com Privacy policy</link-privacy-policy></p>"
        values={{
          p: chunk => <p>{chunk}</p>,
          'link-terms-and-conditions': (chunk: string) => (
            <Button modifier="link" onClick={onClickTermsAndCondition}>
              {chunk}
            </Button>
          ),
          'link-privacy-policy': (chunk: string) => (
            <Button modifier="link" onClick={onClickPrivacyPolicy}>
              {chunk}
            </Button>
          ),
        }}
      />

      {showSAText && (
        <p>
          <FormattedMessage
            id="totalPrice.info.text2"
            defaultMessage="Your Sustainable Actions (SA) contribution may be tax deductible if allowed by applicable laws. Please consult with your accountant or other tax professional for a determination."
          />
        </p>
      )}

      <WarningStyled>
        <FormattedMessage
          id="totalPrice.warning"
          defaultMessage="This amount is not subject to refund."
        />
      </WarningStyled>

      <ControlsWrapperStyled>
        <Button isFullWidth onClick={() => navigate(-1)}>
          <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
        </Button>

        <Button
          isInverted
          isFullWidth
          disabled={!isValid}
          isLoading={isLoading}
          onClick={onClickNext}
        >
          <FormattedMessage id="common.next" defaultMessage="Next" />
        </Button>
      </ControlsWrapperStyled>
    </SectionWrapperStyled>
  );
};

export default Total;
